/**
 * NeedToKnow.jsx
 * Created by Emily Gullo on 04/27/2018.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from './icons/Icons';
import DisplayHtmlContent from './DisplayHtmlContent';

const propTypes = {
    name: PropTypes.string,
    siteInfo: PropTypes.string,
    listItems: PropTypes.array,
    checkboxText: PropTypes.string,
    handleChange: PropTypes.func
};

export default class NeedToKnow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            consentBoxChecked: false
        };

        this.createList = this.createList.bind(this);
        this.getInfo = this.getInfo.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
    }

    getInfo() {
        // return site information if it exists, maintaining any HTML it contains
        let info = null;

        if (this.props.siteInfo) {
            info = <DisplayHtmlContent html={this.props.siteInfo} />
        }

        return info;
    }

    createList() {
        let list = null;
        const items = this.props.listItems;

        if (items) {
            list = [];

            // loop through each item in the list of warnings, create an LI for it
            items.forEach((item, i) => {
                list.push(
                    <li key={i}>
                        <DisplayHtmlContent html={item.notice_text} />
                    </li>
                );
            });

            list = <ul>{list}</ul>;
        }

        return list;
    }

    toggleCheckBox() {
        // toggle status of the checkbox
        if (typeof this.props.handleChange === 'function') {
            this.props.handleChange();
        }
        this.setState({
            consentBoxChecked: !this.state.consentBoxChecked
        });
    }

    render() {
        return (
            <section className="rec-order-detail-need-to-know">
                <div className="rec-section-header">Need to Know</div>

                <div className="rec-notification-warning">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning className="rec-icon-warning" />
                    </span>
                    <div className="rec-notification-body">
                        <div className="rec-notification-title">Important information</div>
                        <p>
                            Below you will find important information that regards your stay with
                            us. Please carefully read the information and click the check box below
                            to agree to our Rules and Regulations for {this.props.name}.
                        </p>
                    </div>
                </div>
                <div className="information">
                    <div className="rec-information-head">
                        Facility Information
                    </div>
                    { this.getInfo() }
                    { this.createList() }
                </div>
                <fieldset className="rec-form-check-wrap">
                    <label htmlFor="checkbox-need-to-know" className="rec-label-checkbox">
                        <input
                            className="rec-input-hide"
                            type="checkbox"
                            id="checkbox-need-to-know"
                            name="checkbox"
                            checked={this.state.consentBoxChecked}
                            onChange={() => this.toggleCheckBox()} />
                        <span className="rec-input-checkbox" /> {this.props.checkboxText}
                    </label>
                </fieldset>
            </section>
        );
    }
}
NeedToKnow.propTypes = propTypes;
